<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>SALDO ANUAL DOS CONTRATOS</span>
                </h4>
                <filtros
                    :fornecedores="fornecedores"
                    @filtroAtualizado="filtro = $event"
                    @pesquisar="obterRelatorio()"
                ></filtros>
                <painel-saldo-anual-contratos
                    :relatorio="relatorio"
                ></painel-saldo-anual-contratos>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import RelatoriosServicos from '../RelatoriosServicos';
import PainelSaldoAnualContratos from './PainelSaldoAnualContratos.vue';
import Filtros from './Filtros.vue';

export default {

    data() {
        return {
            relatorio: null,
            filtro: null,
            fornecedores: null
        }
    },

    components: {
        PainelSaldoAnualContratos,
        Filtros
    },

    methods: {
        obterRelatorio() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterRelatorioSaldoAnual(this.filtro).then((response) => {
                if (response) {
                    if (response.success) {
                        this.relatorio = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter relatorio',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFiltrosOpcoes(){
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterFIltroOpcoesPaineis().then((response) => {
                if (response) {
                    if (response.success) {
                        this.fornecedores = response.data.Fornecedores
                        this.fornecedores.unshift({codFornecedor: null, nome: 'TODOS'})
                    }
                }
                this.$store.dispatch('removeRequest')
                this.obterRelatorio()
            })
        }
    },

    created() {
        this.obterFiltrosOpcoes()
    }
}
</script>